import { Spin } from "antd";
import React from "react";
import "./style.scss";
import { LoadingOutlined } from "@ant-design/icons";

const Btn = ({
  text,
  secondary = false,
  className = "",
  onClick = () => {},
  loading = false,
  disabled = false,
}) => {
  return (
    <div className="btn-wrapper" data-secondary={secondary}>
      <button
        disabled={loading || disabled}
        onClick={onClick}
        className={`lh-24 fs-14 fw-600 ${className}`}
      >
        {loading ? (
          <>
            <Spin
              indicator={
                <LoadingOutlined color="#fff" style={{ color: "#fff" }} spin />
              }
            />
          </>
        ) : typeof text == "string" ? (
          text
        ) : (
          text()
        )}
      </button>
    </div>
  );
};

export default Btn;
